import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { nikola } from "@/data/site";
import { FadeUp } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

export const Portrait = ({ className }) => (
  <figure data-testid="nikola-portrait" className={cn("panel aspect-[4/5] relative overflow-hidden bg-[#f2f1f4]", className)}>
    <picture>
      <source srcSet="/nikola.webp" type="image/webp" />
      <img src="/nikola.jpg" alt={`${nikola.name}, ${nikola.role} der NIVO Garage`} width="960" height="1200" loading="lazy" decoding="async" className="h-full w-full object-cover object-top" />
    </picture>
    <figcaption className="absolute left-4 bottom-4 rounded-lg bg-[rgba(8,8,10,0.78)] backdrop-blur-md px-3.5 py-2.5 text-[13px] leading-tight">
      <span className="block font-medium text-[color:var(--ink)]">{nikola.name}</span>
      <span className="text-[color:var(--ink-2)]">{nikola.role} · {nikola.title}</span>
    </figcaption>
  </figure>
);

export const Nikola = () => (
  <section data-testid="nikola-section" className="section border-t hairline">
    <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <FadeUp className="lg:col-span-5 max-w-sm mx-auto lg:mx-0 w-full">
        <Portrait />
      </FadeUp>
      <div className="lg:col-span-7">
        <FadeUp><p className="eyebrow mb-4">Über uns</p></FadeUp>
        <FadeUp delay={0.05}><h2 className="h-section">Ein Gesicht.<br />Ein Ansprechpartner.</h2></FadeUp>
        <FadeUp delay={0.1} className="lead mt-6 max-w-xl">
          Lernen Sie {nikola.name} kennen: {nikola.role} und ausgebildeter {nikola.title}. Fachwissen trifft auf persönliche Beratung.
        </FadeUp>
        <FadeUp delay={0.15} className="mt-8 flex flex-wrap gap-x-10 gap-y-4">
          {nikola.facts.map((f) => (
            <div key={f.y}>
              <p className="text-[13px] text-[color:var(--ink-3)] mono">{f.y}</p>
              <p className="text-[color:var(--ink)] font-medium">{f.t}</p>
            </div>
          ))}
        </FadeUp>
        <FadeUp delay={0.2} className="mt-9">
          <Link to="/ueber-uns" data-testid="nikola-about-link" className="inline-flex items-center gap-2 text-[color:var(--violet)] hover:text-[color:var(--ink)] transition-colors">Mehr über Nikola und NIVO <ArrowRight className="h-4 w-4" /></Link>
        </FadeUp>
      </div>
    </div>
  </section>
);
